// PR-29: Capacitor platform detection helpers.
//
// `Capacitor.isNativePlatform()` returns true only when the bundle runs
// inside a Capacitor WebView (iOS / Android). On a regular browser it
// returns false, so callers can branch native-only behavior without
// crashing the web build.
import { Capacitor } from '@capacitor/core';

export const isCapacitor = (): boolean => Capacitor.isNativePlatform();
export const isIOS = (): boolean => Capacitor.getPlatform() === 'ios';
export const isAndroid = (): boolean => Capacitor.getPlatform() === 'android';
export const isWeb = (): boolean => Capacitor.getPlatform() === 'web';
